module.exports = __webpack_public_path__ + "img/4.cea0331b.png";